import { useEffect, useState } from 'react'

const useNavData = (data) => {
  const [loaded, setLoaded] = useState(false)
  const [strapiNavigation, setStrapiNavigation] = useState(data.strapiNavigation)
  useEffect(() => {
    if (!loaded) {
      setLoaded(true)
    } else {
      setStrapiNavigation(
        data.strapiNavigation
      )
    }
  }, [])
  return {
    strapiNavigation,
  }
}

const getSubNavData = (strapiNavigation) => {
  const MenuData = strapiNavigation?.NavCategories.map((category) => {
    let categoryRoot = {
      title: category.CategoryName,
      to: category.to,
      subItems: [],
      Tiles: category.Tiles,
      QuizTitle: category.QuizTitle,
      QuizLink: category.QuizLink,
      Highlight: category.Highlight,
    }

    let currentSub = {
      items: [],
    }
    for (let item of category.Items) {
      if (item.isTitle) {
        if (currentSub.title === undefined) {
          currentSub.title = item.text
        } else {
          categoryRoot.subItems.push({ ...currentSub })
          currentSub = {
            items: [],
            title: item.text,
          }
        }
      } else {
        currentSub.items.push({
          title: item.text,
          to: item.to,
          image: item.NavImage,
          new: item.new,
          restocked: item.restocked,
          ItemLabel: item?.ItemLabel
        })
      }
    }
    categoryRoot.subItems.push({ ...currentSub })
    return categoryRoot
  })
  return MenuData
}

const getNavData = (strapiNavigation) => {
  return strapiNavigation?.NavBarLinks.map((link) => link)
}

export { getNavData, getSubNavData, useNavData }
